<template>
    <Dialog :open="isOpen" @close="$emit('close')">
        <div class="fixed inset-0 bg-black/50 z-[60]" aria-hidden="true" />
        <div class="fixed inset-0 z-[70] overflow-y-auto">
            <div class="flex min-h-full items-center justify-center p-4">
                <DialogPanel class="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden shadow-xl">
                    <div class="flex justify-between items-center p-6 border-b border-border">
                        <DialogTitle class="text-2xl font-bold text-gray-900">
                            <slot name="title" />
                        </DialogTitle>
                        <button
                            @click="$emit('close')"
                            class="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                            aria-label="Close"
                        >
                            <XMarkIcon class="w-6 h-6 text-gray-500" />
                        </button>
                    </div>
                    <div class="p-6 overflow-y-auto max-h-[calc(90vh-100px)]">
                        <slot />
                    </div>
                </DialogPanel>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/vue';
import { XMarkIcon } from '@heroicons/vue/24/outline';

export default defineComponent({
    name: 'Modal',
    components: {
        Dialog,
        DialogPanel,
        DialogTitle,
        XMarkIcon
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true
        }
    },
    emits: ['close']
});
</script>
